import React, { useEffect } from 'react';
import { LoadingSpinner } from 'triider-components';

export default function AbsoluteRedirect({ to }) {
  useEffect(() => {
    window.location = to;
  }, []);

  return <LoadingSpinner loadingVisible />;
}
